module.exports = {
  path: '',
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/companies'),
        require('./routes/devices'),
        require('./routes/deviceSlaves'),
        require('./routes/distributions'),
        require('./routes/installations'),
        require('./routes/production'),
        require('./routes/profiles'),
        require('./routes/rollouts'),
        require('./routes/simcards'),
        require('./routes/users'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/index.js